import styles from './ChatStyle.module.css'
import ChatIcon from '../chatIcon/ChatIcon'
import ChatBox from '../chatBox/ChatBox'
import { useState } from 'react'

/**
 * Combination of Chat Icon and Chat Box
 * @returns 
 */
const Chat = () => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <div className={styles.chat}>
        <ChatBox isOpen={isOpen} setOpen={setOpen} />
        <ChatIcon onClick={() => setOpen(prev => !prev)} />
    </div>
  )
}

export default Chat
